var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.93484 9.41936L3.20001 9.68452L3.46517 9.41936L6.00001 6.88452L8.53484 9.41936L8.80001 9.68452L9.06517 9.41936L9.41917 9.06536L9.68434 8.80019L9.41917 8.53503L6.88434 6.00019L9.41917 3.46536L9.68434 3.20019L9.41917 2.93503L9.06517 2.58103L8.80001 2.31586L8.53484 2.58103L6.00001 5.11586L3.46517 2.58103L3.20001 2.31586L2.93484 2.58103L2.58084 2.93503L2.31568 3.20019L2.58084 3.46536L5.11568 6.00019L2.58084 8.53503L2.31568 8.80019L2.58084 9.06536L2.93484 9.41936Z",
    fill: "#060606",
    stroke: "#060606",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackClose);
export default __webpack_public_path__ + "static/media/black-close.e610ee29550634a777fc799ecfdff980.svg";
export { ForwardRef as ReactComponent };